import { css, cx, useTheme } from '@fable/theme'
import {
  AuthorStats,
  MomBooksStats,
  RatingStats,
  StatsBackground,
  StatsHero,
  StatsLoader,
  StatsReaderSummary,
  StreakStats,
} from './components'
import { FlexBox } from '@fable/components'
import { GenreStats } from './components/genres'
import { motion } from 'framer-motion'
import { useRef } from 'react'
import { useStats } from './lib/ctx/stats'
import { StatsToolbar } from './components/StatsToolbar'
import { StatsWebViewHooks } from './StatsWebViewHooks'

export const Stats = () => {
  const [isSharing, isProfileView, status, theme, isOnboarding, isDesktop] =
    useStats((s) => [
      s.isSharing,
      s.isProfileView,
      s.status,
      s.theme,
      s.isOnboarding,
      s.isDesktop,
    ])
  const { mediaQueries } = useTheme()
  const momRef = useRef<HTMLDivElement>(null)

  const backgroundHeight = momRef.current
    ? momRef.current?.offsetTop + momRef.current?.offsetHeight / 2
    : 0

  const getContent = () => {
    if (status === 'loadingYear') {
      return (
        <StatsLoader
          className={css`
            margin-top: ${isProfileView ? 0 : -54}px;
          `}
          color={`${theme.accent}40`}
          bgColor="transparent"
        />
      )
    }

    return (
      <>
        {!isProfileView ? <StatsHero /> : null}
        <div
          className={cx(
            css`
              padding: 0 20px;
              padding-top: ${isOnboarding && isProfileView ? 20 : 2}px;
              width: 100%;
              ${isProfileView && mediaQueries.mobileL} {
                padding-top: 20px;
              }
            `
          )}
        >
          <StatsReaderSummary />
          <FlexBox
            className={css`
              gap: 20px;
            `}
            flexDirection="column"
          >
            <MomBooksStats ref={momRef} />
            <StreakStats />
            <GenreStats />
            <RatingStats />
            <AuthorStats />
          </FlexBox>
        </div>
      </>
    )
  }

  return (
    <>
      {isDesktop ? null : <StatsWebViewHooks />}
      <motion.div
        data-testid="stats"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1 },
          sharing: { opacity: 0.25 },
        }}
        initial="hidden"
        animate={isSharing ? 'sharing' : 'visible'}
        transition={{ duration: 0.4, ease: 'easeInOut' }}
        className={css`
          padding-bottom: 20px;
          position: relative;
        `}
      >
        {!isProfileView ? (
          <StatsBackground
            className={css`
              height: ${backgroundHeight}px;
            `}
          />
        ) : null}
        <div
          className={css`
            position: relative;
            padding-top: ${isProfileView ? 0 : 80}px;
          `}
        >
          <StatsToolbar />
          {getContent()}
        </div>
      </motion.div>
    </>
  )
}
